export let TripStatus = {
    1: 'Provisional',
    2: 'In preparation',
    3: 'Ready',
    4: 'Cancelled',
    5: 'Archived',
};